import React, { FC } from 'react'
import Image from 'next/image'
import { CountryWithIcon } from '@entities/country'
import { useCyberStore } from '@entities/tsp'
import { ICON_TCP } from '@shared/config'
import { Select, SelectOption } from '@shared/ui/organisms'

interface CountrySelectProps {
  countryVouchers: CountryWithIcon[]
}

const CountrySelect: FC<CountrySelectProps> = ({ countryVouchers }) => {
  const { activeCountry, setActiveCountry } = useCyberStore()

  const options = countryVouchers?.map(({ country, icon }) => ({
    value: country,
    label: country,
    icon: icon && <Image src={`${ICON_TCP}${icon}`} alt="icon" height={52} width={52} />,
  }))

  const handleCountryChange = (option: SelectOption) => {
    setActiveCountry(option.value)
  }

  const selectedOption = options.find((option) => option.value === activeCountry) || null

  return (
    <Select color="tertiary" value={selectedOption} placeholder="" onSelect={handleCountryChange} options={options} />
  )
}

export default CountrySelect
